module.exports = __webpack_public_path__ + "img/cn5.b58ecf3.png";